import React from 'react'
import { CDrawerSection } from './styles'

const CDrawer = ({ renderDrawer, displayDrawer }) => {
	return (
		<CDrawerSection>
			{renderDrawer()}
		</CDrawerSection>
	)
}

export default React.memo(CDrawer)
